<template>
  <div class="menu-page">
    <!-- Primary Actions: Deposit / Withdraw -->
    <div class="menu-actions">
      <button class="menu-actions__btn menu-actions__btn--deposit" @click="gotoActive(0)">
        <van-icon name="balance-o" size="24" />
        <span>{{ $lang.Depósito }}</span>
      </button>
      <button class="menu-actions__btn menu-actions__btn--withdraw" @click="gotoActive(1)">
        <van-icon name="cash-back-record" size="24" color="#93c5fd" />
        <span>{{ $lang.Saque }}</span>
      </button>
    </div>

    <!-- Region Selector -->
    <div class="menu-region-wrap">
      <div class="menu-region" @click="toggleCountryDrop">
        <div class="menu-region__left">
          <van-icon name="location-o" size="18" color="#94a3b8" />
          <span class="menu-region__label">{{ $lang.menu_region || 'Region' }}</span>
        </div>
        <div class="menu-region__right">
          <img :src="GET_ICONURL" width="20" class="menu-region__flag" />
          <span class="menu-region__name">{{ GET_COUNTRYNAME }}</span>
          <van-icon :name="showCountryDrop ? 'arrow-up' : 'arrow-down'" size="12" color="#64748b" />
        </div>
      </div>
      <div v-if="showCountryDrop" class="menu-country-dropdown">
        <div
          v-for="(item, idx) in countryList"
          :key="idx"
          class="menu-country-dropdown__item"
          @click="selectCountryMenu(item)"
        >
          <img :src="item.iconUrl" width="24" />
          <span>{{ item.countryName }}</span>
          <span class="menu-country-dropdown__code">{{ item.areaCode }}</span>
        </div>
        <div v-if="countryList.length === 0" class="menu-country-dropdown__item" style="justify-content: center; color: #6b7280;">
          {{ $lang.common_loading || 'Loading...' }}
        </div>
      </div>
    </div>

    <!-- Our Communities -->
    <div class="menu-section">
      <p class="menu-section__title">{{ $lang.common_txt279 }}</p>
      <div class="menu-social">
        <a
          v-for="(item, index) in socialList"
          :key="index"
          class="menu-social__item"
          @click="goToSocial(index)"
        >
          <img :src="item.icon" width="28" />
        </a>
      </div>
    </div>

    <!-- Activity Grid (2x2) -->
    <div class="menu-grid">
      <div
        v-for="(item, index) in activityGrid"
        :key="index"
        class="menu-grid__item"
        @click="goToAAA(index)"
      >
        <img :src="item.img" class="menu-grid__img" />
        <div class="menu-grid__text">
          <p class="menu-grid__name">{{ item.name }}</p>
          <p class="menu-grid__desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>

    <!-- Mini Games (2 tall cards) -->
    <div class="menu-games">
      <div
        v-for="(item, index) in gameList"
        :key="index"
        class="menu-game-card"
        :class="'menu-game-card--' + item.theme"
        @click="goToBBB(index)"
      >
        <div class="menu-game-card__top">
          <div class="menu-game-card__icon" :class="'menu-game-card__icon--' + item.theme">
            <img :src="item.icon" width="132" />
          </div>
          <van-icon name="arrow" size="12" color="#64748b" />
        </div>
        <div class="menu-game-card__bottom">
          <p class="menu-game-card__label">{{ item.label }}</p>
          <h3 class="menu-game-card__name">{{ item.name }}</h3>
        </div>
      </div>
    </div>

    <!-- Telegram Section -->
    <div class="menu-section">
      <p class="menu-section__title">{{ $lang.common_txt280 }}</p>
      <div class="menu-social">
        <a
          v-for="(item, index) in telegramList"
          :key="index"
          class="menu-social__item"
          @click="goToDDD(index)"
        >
          <img :src="item.icon" width="28" />
        </a>
      </div>
    </div>

    <!-- Function List -->
    <nav class="menu-nav">
      <div
        v-for="(item, index) in mtList"
        :key="index"
        class="menu-nav__item"
        @click="goToCCC(index)"
      >
        <div class="menu-nav__left">
          <img :src="item.icon" width="16" />
          <span>{{ item.name }}</span>
        </div>
      </div>
    </nav>

    <!-- Bottom Banner -->
    <div class="menu-banner">
      <img src="../../assets/img/otgame/dibeijing.jpg" width="100%" />
      <p class="menu-banner__text">
        {{ $lang.common_txt286 }} ot.game
      </p>
    </div>

  </div>
</template>

<script>
import { GetPlatformList } from '@/api/common'
import { logoutIfReloginRequiredWithToken } from '@/utils/platformAuth'

export default {
  name: 'MenuPage',
  data() {
    return {
      showLang: false,
      showCountryDrop: false,
      countryList: [],
      socialList: [
        { icon: require('@/assets/img/otgame/zjm_39.png') },
        { icon: require('@/assets/img/otgame/pinduoduo_24.png') },
        { icon: require('@/assets/img/otgame/ins.png') },
        { icon: require('@/assets/img/otgame/zjm_42.png') }
      ],
      telegramList: [
        { icon: require('@/assets/img/otgame/group-chat.png') },
        { icon: require('@/assets/img/otgame/channel.png') }
      ],
      mtList: [
        {
          icon: require('@/assets/img/otgame/cebianlan_12.png'),
          name: this.$lang.common_txt282
        },
        {
          icon: require('@/assets/img/otgame/cebianlan_13.png'),
          name: this.$lang.common_txt283
        },
        {
          icon: require('@/assets/img/otgame/cdk.png'),
          name: this.$lang.common_txt284
        },
        {
          icon: require('@/assets/img/otgame/hezuo.png'),
          name: this.$lang.common_txt285
        }
      ]
    }
  },
  computed: {
    activityGrid() {
      return [
        { img: require('@/assets/img/activityGrid/1.jpg'), name: 'VIP Club', desc: 'Join & Level Up' },
        { img: require('@/assets/img/activityGrid/2.jpg'), name: 'Invite Bonus', desc: 'Earn $10 Now' },
        { img: require('@/assets/img/activityGrid/3.jpg'), name: 'Missions', desc: 'Daily Rewards' },
        { img: require('@/assets/img/activityGrid/4.jpg'), name: 'Rebate', desc: 'Up to 5% back' }
      ]
    },
    gameList() {
      return [
        {
          icon: require('@/assets/img/otgame/LuckyWheel.png'),
          label: 'Daily Fortune',
          name: 'Lucky Wheel',
          theme: 'green'
        },
        {
          icon: require('@/assets/img/otgame/LuckyDraw.png'),
          label: 'Epic Rewards',
          name: 'Lucky Draw',
          theme: 'gold'
        }
      ]
    }
  },
  methods: {
    toggleCountryDrop() {
      this.showCountryDrop = !this.showCountryDrop
      if (this.showCountryDrop && this.countryList.length === 0) {
        this.fetchCountryList()
      }
    },
    async fetchCountryList() {
      try {
        const data = await GetPlatformList()
        if (data.status === 'ok') {
          this.countryList = data.content.list
        }
      } catch (e) {
        console.error('fetchCountryList error', e)
      }
    },
    selectCountryMenu(item) {
      const prevPlatform = localStorage.getItem('platform')
      logoutIfReloginRequiredWithToken(prevPlatform, item.platform)
      localStorage.setItem('currency', item.currency)
      localStorage.setItem('areaCode', item.areaCode)
      localStorage.setItem('currencyUnit', item.currencyUnit)
      localStorage.setItem('platform', item.platform)
      localStorage.setItem('defaultLanguage', item.defaultLanguage)
      localStorage.setItem('iconUrl', item.iconUrl)
      localStorage.setItem('countryName', item.countryName)
      localStorage.setItem('country', item.country)
      this.showCountryDrop = false
      this.$router.replace('/' + item.country + '/home')
      setTimeout(() => { window.location.reload() }, 200)
    },
    gotoActive(i) {
      if (this.token) {
        if (i === 0) {
          this.$jumpTo('./rechargeCont')
        } else {
          this.$jumpTo('./bankAdd')
        }
      } else {
        this.$bus.$emit('openLogin')
      }
    },
    goToAAA(i) {
      if (i === 0) {
        this.$jumpTo('/vipLevels')
      } else if (i === 1) {
        this.$jumpTo('/Alliance')
      } else if (i === 2) {
        this.$dialog.alert({
          title: this.$lang.activity_coming_soon || 'Coming Soon',
          message: this.$lang.activity_stay_tuned || 'Stay tuned, something amazing is coming!',
          confirmButtonText: 'OK',
          confirmButtonColor: '#24ee89'
        })
      } else if (i === 3) {
        this.$jumpTo('/luckyReferral')
      }
    },
    goToBBB(i) {
      if (i === 0) {
        this.$jumpTo('/luckyReferral')
      } else if (i === 1) {
        this.$jumpTo('/luckyDraw')
      }
    },
    goToCCC(i) {
      if (i === 0) {
        this.$jumpTo('/privacy')
      } else if (i === 1) {
        this.$jumpTo('/Support')
      } else if (i === 2) {
        this.$jumpTo('/redPacket')
      } else if (i === 3) {
        this.$jumpTo('/Alliance')
      }
    },
    goToDDD(i) {
      if (i === 0) {
        window.open('https://t.me/OTGAME777', '_blank')
      } else if (i === 1) {
        window.open('https://t.me/OTgamel', '_blank')
      }
    },
    goToSocial(i) {
      const urls = [
        'https://facebook.com',
        'https://twitter.com',
        'https://instagram.com',
        'https://tiktok.com'
      ]
      if (urls[i]) {
        window.open(urls[i], '_blank')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@primary: #24ee89;
@gold: #f8f510;
@bg-dark: #0A0E1A;
@card-dark: #1E293B;

.menu-page {
  min-height: 100vh;
  background: @bg-dark;
  padding: 16px;
  padding-bottom: 80px;
}

// ====== PRIMARY ACTIONS ======
.menu-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;

  &__btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 64px;
    border-radius: 16px;
    border: none;
    cursor: pointer;
    font-size: 11px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 0.1em;

    &:active {
      transform: scale(0.95);
    }

    &--deposit {
      background: @gold;
      color: #000;
      box-shadow: 0 4px 15px fade(@gold, 30%);
    }

    &--withdraw {
      background: #1E3A8A;
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.1);
      box-shadow: 0 4px 15px rgba(30, 58, 138, 0.3);
    }
  }
}

// ====== REGION SELECTOR ======
.menu-region-wrap {
  position: relative;
  margin-bottom: 20px;
}
.menu-region {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: fade(@card-dark, 40%);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  cursor: pointer;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #cbd5e1;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #0F172A;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }

  &__flag {
    border-radius: 2px;
    object-fit: cover;
  }

  &__name {
    font-size: 12px;
    font-weight: 700;
    color: #f1f5f9;
  }
}
.menu-country-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 100;
  background: #252936;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  margin-top: 4px;

  &__item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    cursor: pointer;
    font-size: 13px;
    color: #ffffff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);

    &:last-child { border-bottom: none; }
    &:active { background: rgba(36, 238, 137, 0.1); }
  }

  &__code {
    margin-left: auto;
    color: #24ee89;
    font-weight: 600;
    font-size: 12px;
  }
}

// ====== SECTION ======
.menu-section {
  margin-bottom: 20px;

  &__title {
    font-size: 10px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    padding-left: 4px;
    margin-bottom: 12px;
  }
}

// ====== SOCIAL ======
.menu-social {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  background: fade(@card-dark, 20%);
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.05);

  &__item {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: @card-dark;
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;

    &:active {
      border-color: fade(@primary, 50%);
      transform: scale(1.05);
    }
  }
}

// ====== ACTIVITY GRID ======
.menu-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;

  &__item {
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    aspect-ratio: 1;
    background: #1e293b;
    cursor: pointer;

    &:active {
      transform: scale(0.98);
    }
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
  }

  &__item:active &__img {
    transform: scale(1.05);
  }

  &__text {
    position: absolute;
    bottom: 8px;
    left: 8px;
  }

  &__name {
    font-size: 10px;
    font-weight: 700;
    color: @primary;
    text-transform: uppercase;
    line-height: 1.2;
  }

  &__desc {
    font-size: 8px;
    color: #cbd5e1;
    margin-top: 2px;
  }
}

// ====== GAME CARDS ======
.menu-games {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.menu-game-card {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  height: 120px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  &--green {
    background: linear-gradient(135deg, #312e81, #581c87, #1e293b);
  }

  &--gold {
    background: linear-gradient(135deg, #0f172a, #172554, #451a03);
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__icon {
    width: 168px;
    height: 48px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &--green {
      border: 1px solid fade(@primary, 20%);
      box-shadow: 0 0 15px fade(@primary, 20%);
    }

    &--gold {
      border: 1px solid fade(@gold, 20%);
      box-shadow: 0 0 15px fade(@gold, 20%);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__bottom {
    // at bottom
  }

  &__label {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    margin-bottom: 2px;
    color: @primary;

    .menu-game-card--gold & {
      color: @gold;
    }
  }

  &__name {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
  }

  &:active {
    transform: scale(0.98);
  }
}

// ====== FUNCTION NAV LIST ======
.menu-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: 12px;
    color: #94a3b8;
    cursor: pointer;
    transition: all 0.2s;

    &:active {
      background: fade(@card-dark, 40%);
      color: #f1f5f9;
    }

    &--highlight {
      background: fade(@primary, 5%);
      border: 1px solid fade(@primary, 10%);

      .menu-nav__left span {
        color: @primary;
        font-weight: 600;
      }
    }
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 16px;

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }

  &__dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: @primary;
  }
}

// ====== BOTTOM BANNER ======
.menu-banner {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  margin-top: 16px;

  img {
    display: block;
    width: 100%;
  }

  &__text {
    text-align: center;
    text-decoration: underline;
    color: #72c9d1;
    padding: 8px 0;
    font-size: 12px;
  }
}

// ====== RESPONSIVE ======
@media (min-width: 769px) {
  .menu-page {
    max-width: 450px;
    margin: 0 auto;
  }
}
</style>
